/**
 * @ngdoc function
 * @name isActive
 * @description checks for the active state
 *
 *
 */

export function isActive($state, key) {
  return ($state.current.name.match(new RegExp(key + '.*'))) ? true : false;
}
